// extracted by mini-css-extract-plugin
export var productImage = "_ro-1";
export var viewLink = "_ro-2";
export var wishlistItem = "_ro-0";